<template>
  <a :href="href" rel="block noopener noreferrer" @click.left="onClick">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    platform: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: window.location.href,
    },
    title: {
      type: String,
      default: document.title,
    },
  },

  data() {
    return {
      platforms: {
        facebook: {
          name: 'facebook',
          href: 'https://www.facebook.com/sharer/sharer.php?u=%URL%',
          width: 400,
          height: 500,
        },
        twitter: {
          name: 'twitter',
          href: 'https://twitter.com/intent/tweet?status=%TITLE%+-+%URL%',
          width: 540,
          height: 260,
        },
        linkedin: {
          name: 'linkedin',
          href: 'https://www.linkedin.com/sharing/share-offsite/?url=%URL%',
          width: 520,
          height: 570,
        },
      },
    };
  },

  computed: {
    thePlatform() {
      return this.platforms[this.platform];
    },

    finalImage() {
      if (this.image) {
        return this.image;
      }

      var image = '';

      var og_image = document.querySelector('meta[property="og:image"]');

      if (og_image) {
        image = og_image.getAttribute('content');
      } else {
        var images = document.getElementsByTagName('img');

        if (images.length > 0) {
          image = images[0].getAttribute('src');
        }
      }

      return image;
    },

    href() {
      return this.thePlatform.href
        .replace('%URL%', encodeURIComponent(this.url).replace(/%20/g, '+'))
        .replace('%TITLE%', encodeURIComponent(this.title).replace(/%20/g, '+'))
        .replace('%IMAGE%', encodeURIComponent(this.finalImage).replace(/%20/g, '+'));
    },
  },

  methods: {
    onClick(e) {
      if (!this.thePlatform.sameWindow) {
        e.preventDefault();
      }

      if (!this.thePlatform.sameWindow) {
        window.open(
          this.href,
          '',
          `status=yes, width=${this.thePlatform.width}, height=${this.thePlatform.height}`
        );
      }
    },
  },
};
</script>
